import React, {useState, useEffect, useRef} from "react";

const FitHeight = ({HTMLelement="div", height, initialFZ=30, className, children}) => {
  const [fz, setFz] = useState(initialFZ);
  const [show, setShow] = useState(false);
  const ref = useRef(null)



  useEffect(() => {
    console.log("ref.current.scrollHeight > height", ref.current.scrollHeight, height)
    if(ref.current.scrollHeight > height) {
      setFz(fz => fz-1)
    }
    else {
      setShow(true)
    }
  }, [fz]);

  return (
    <HTMLelement ref={ref}
    style={{maxHeigt: height, fontSize: fz, opacity: show ? 1 : 0}}
    className={className}
    dangerouslySetInnerHTML={{__html: children}} />
  )
}

export default FitHeight